import AccountService from 'src/common/api/account.service';
import { LocalStorage } from 'quasar';
import constants from 'src/common/constants';

export async function boot({ dispatch }) {
  await dispatch('loadLanguage');
  await dispatch('getLocationConfig');
  await dispatch('airQuality/getAll', null, { root: true });
  // await dispatch('card/getAllCards', null, { root: true });
}

export async function changeLanguage({ commit, dispatch }, { language }) {
  commit('setLanguage', { language });
  dispatch('saveLanguage', { language });
}

export async function saveLanguage(context, { language }) {
  LocalStorage.set(constants.LOCALSTORAGE_APPLICATION_LANGUAGE, language);
}

export async function loadLanguage({ commit }) {
  if (LocalStorage.has(constants.LOCALSTORAGE_APPLICATION_LANGUAGE)) {
    const language = await LocalStorage.getItem(constants.LOCALSTORAGE_APPLICATION_LANGUAGE);
    if (language) {
      await commit('setLanguage', { language });
    }
  }
}

export async function getAllLocations({ commit }) {
  const response = await AccountService.getLocations();
  if (response.status === 200) {
    commit('setAll', response.data);
  }
}

export async function updateLocationConfig({ commit }, {
  news, events, googleApiKey, suggestionTitles, airQualityStations, containerLocation, email,
}) {
  const response = await AccountService.updateLocationConfig({
    news, events, googleApiKey, suggestionTitles, airQualityStations, containerLocation, email,
  });
  if (response.status === 200) {
    commit('updateLocationConfig', response.data);
    return true;
  }
  return false;
}

export async function getLocationConfig({ commit }) {
  const response = await AccountService.getLocationConfig();
  if (response.status === 200) {
    commit('updateLocationConfig', response.data);
  }
}
